// extracted by mini-css-extract-plugin
export default {"burger":"BurgerMenu_burger__5mXeC","container":"BurgerMenu_container__uedJa","line":"BurgerMenu_line__2OuPL"};